import OBase from './OBase';
import * as Geometry from '../geometry';

export default class ConstructPoint extends OBase {
  update () {
    let xVal = this.getFloatInput('X coordinate');
    let yVal = this.getFloatInput('Y coordinate');
    let zVal = this.getFloatInput('Z coordinate');

    let output = this.getGenericObjectOutput('Point');

    let dataTrees = [];
    var outDataTrees = [];
    dataTrees.push(xVal);
    dataTrees.push(yVal);
    dataTrees.push(zVal);

    Geometry.makeMultiplePairs(dataTrees, outDataTrees);

    let outTree = new Geometry.DataTree();
    for (let i = 0; i < outDataTrees[0].branches.length; i++) {

      if(outDataTrees[0].branches[i].length == 0 || 
        outDataTrees[1].branches[i].length == 0 || 
        outDataTrees[2].branches[i].length == 0
       ){
        let path = outDataTrees[0].paths[i];
        outTree.addEmpty(path);
        continue;
      }  

      for (let j = 0; j < outDataTrees[0].branches[i].length; j++) {
        let x = Number(outDataTrees[0].branches[i][j]);
        let y = Number(outDataTrees[1].branches[i][j]);
        let z = Number(outDataTrees[2].branches[i][j]);
        let val = new THREE.Vector3(x, y, z);
        outTree.add(val, outDataTrees[0].paths[i]);
      }
    }

    output.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/ConstructPoint.js